export enum StateHash {
  Pending = "#pending",
  Fulfilled = "#fulfilled",
  Rejected = "#rejected",
}
